import { Platform, View } from 'react-native';
import React, { useCallback } from 'react';
import {
  Banner,
  Footer,
  Input,
  KeyboardScreenContainer,
  Text,
} from '~/components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useMarisaAutoForm from '~/stores/marisaAutoForm';
import type { MarisaAutoStepsProps } from '../..';
import { useSalesFunnel } from '~/stores';

const schema = yup
  .object()
  .shape({
    cellphone: yup
      .string()
      .required('Este campo é obrigatório')
      .min(15, 'Número inválido'),
  })
  .required();

interface PhoneNumberForm {
  cellphone: string;
}

const PhoneNumber = ({ onContinue }: MarisaAutoStepsProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<PhoneNumberForm>({
    resolver: yupResolver(schema),
  });

  const { setPhoneNumber } = useMarisaAutoForm();
  const { setInfos } = useSalesFunnel();

  const onSubmit = useCallback(
    (data: PhoneNumberForm) => {
      setInfos({ cellphone: data.cellphone });
      setPhoneNumber(data.cellphone);

      onContinue();
    },
    [onContinue, setInfos, setPhoneNumber]
  );
  return (
    <KeyboardScreenContainer
      footer={
        <View
          className={`flex xl:hidden ${
            Platform.OS === 'web' ? 'py-4 px-6' : ''
          }`}
        >
          <Footer onSubmit={handleSubmit(onSubmit)} />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="marisa-auto" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-xl mb-4 text-gray-600">Celular</Text>

          <Text className="text-gray-400 text-sm mb-8">
            Para finalizarmos, precisamos validar o seu contato. Nos informe o
            número do seu celular.
          </Text>

          <Input
            name="cellphone"
            label="Celular"
            placeholder="DDD+Celular"
            control={control}
            error={errors.cellphone?.message}
            maskConfig={{ type: 'cel-phone' }}
            maxLength={15}
            keyboardType="decimal-pad"
          />

          <Footer className="hidden" onSubmit={handleSubmit(onSubmit)} />
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default PhoneNumber;
